import {useParams} from 'react-router-dom';
import {DeviceHealth} from '../../../../../../../components/device-health/device-health';
import {CaregiverMode} from '../../../../../../../enums/caregiver-mode';

export default function DeviceHealthSystemAdministratorOfficeScreen() {
  // Get params
  let {deviceId}: {deviceId?: string} = useParams();

  return (
    <DeviceHealth
      deviceId={deviceId || ''}
      caregiverMode={CaregiverMode.SystemAdministrator}
      canWrite={true}
    />
  );
}
